import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './ui/Countdown';
export function UrgencySection() {
  return <section className="bg-carbon text-center text-snow" aria-label="Limited time offer" data-id="element-295" data-mp="369pga49jt16e">
      <div className="h-1 w-full bg-lava" aria-hidden="true" data-id="element-296" data-mp="31j940nhgrllm" />
      <div className="mx-auto max-w-3xl px-4 py-12" data-id="element-297" data-mp="31ho4ejgalcgw">
        <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[.16em] text-lava" data-id="element-298" data-mp="3g7lzzkgjx4g4">
          <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-299" data-mp="3b9tvzs2mtrvk" /> Launch pricing ends in:
        </p>
        <Countdown className="mt-5" data-id="element-300" data-mp="3p7sacxgydob2" />
        <p className="mt-7 font-bold text-muted" data-id="element-301" data-mp="3p6pl0tza3tx9">After that the price increases and never drops again.</p>

        <div className="mx-auto mt-6 max-w-xl rounded-xl border border-lava/30 bg-petrol p-4 text-sm" data-id="element-302" data-mp="3l543gvbsurgq">
          <p className="font-bold text-snow" data-id="element-303" data-mp="1uwlx47g5ks5z">
            <span className="mr-2 inline-block h-2.5 w-2.5 animate-pulse rounded-full bg-lava" data-id="element-304" data-mp="1qu8sxnh212bb" />
            Remaining launch pricing spots: limited
          </p>
          <div className="mt-3 h-3 overflow-hidden rounded-full bg-carbon" data-id="element-305" data-mp="2xsr58na4zx9r">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '66%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.9,
            ease: [0.23, 1, 0.32, 1]
          }} className="h-full rounded-full bg-energy" data-id="element-306" data-mp="2xqogs7omuc75" />
          </div>
          <p className="mt-1 text-right text-xs text-muted" data-id="element-307" data-mp="3cjq7zhoajrlf">66% of spots taken</p>
        </div>
      </div>
      <div className="h-1 w-full bg-lava" aria-hidden="true" data-id="element-308" data-mp="3gl3fdw7182ug" />
    </section>;
}